var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.devices),function(device){return _c('tree-view',{key:device.id,attrs:{"name":device.name,"data":device,"paths":_vm.dynamicPath,"root":_vm.root,"padd":false}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }